const PAGE_VIEW_TYPES = {
  Install: '10650100748',
  Upgrade: '10650100746',
  'Developer Space': '10650100738',
  WxwMulti: '10650100736',
  'System Info': '10650100750',
  'Data Transfer': '10650100752',
  'System Recovery(Single Disk)': '10650100754',
  'System Recovery(Full Disk)': '10650100754',
  TimeCalibrator: '10650100756',
  'WFH Preparation': '10650100758',
  'Pc Optimize': '10650100760',
  'Reset Browser': '10650100762',
  Account: '10650100764',
  'Performance Test': '10650100768',
  'IT Service Center': '10650100766',
  'Network Test': '10650100770',
  'Disk Clean': '10650100772',
  'PC Administrator': '10650100774',
  'Host Edit': '10650100776',
  RDP: '10650100778',
  Home: '10650101750',
  'Software Application': '10650106238',
  Uninstall: '10650131922',
  Error: '10650139818',
};

export default PAGE_VIEW_TYPES;
